<template>
	<div>
		<div class="col-12 pt-3 px-0">
			<h2 class="title-3 text-grey-900 w-100 pb-4">
				{{ content.station_whereIsLocated }}
			</h2>
			<Map />
		</div>
	</div>
</template>

<script>
// components
import Map from "@/vue/map/components/map.vue";

export default {
	name: "MapApp",
	components: {
		Map,
	},
	computed: {
		content() {
			return window.content;
		},
	},
};
</script>

<style>
.vue-map-container .vue-map {
	border-radius: 20px;
}
</style>
